module.exports = __webpack_public_path__ + "static/media/localguide.847873a8.gif";